import { REQUEST, RESPONSE, ERROR } from '../actions/emailSettings';


const INITIAL_STATE = {
  email: null,
  error: null,
  loading: false,
  receiveEmails: false,
};


export default (state = INITIAL_STATE, action = {}) => {
  const { type, error, payload = {} } = action;
  const { email_settings: emailSettings = {} } = payload;
  const { email, recv_emails: rawReceiveEmails = null } = emailSettings;

  // Cast API response value to Boolean (currently API responds with `0` for
  // `false` and `1` for `true`)
  const receiveEmails = rawReceiveEmails === null
    ? null
    : Boolean(rawReceiveEmails);

  switch (type) {
    case REQUEST:
      return Object.assign({}, state, {
        loading: true,
        error: null,
      });

    case RESPONSE:
      return {
        loading: false,
        error: null,
        email,
        receiveEmails,
      };

    case ERROR:
      return Object.assign({}, state, {
        loading: false,
        error,
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/emailSettings.js